import React from "react";
import styled from "styled-components";
import TopbarMost from "../Common/TopbarMost";
import { NewTheme } from "../Theme/Theme";
import CustomerTable from "./CustomerTable";
import AddCustomerModal from "./Modal/AddCustomerModal";

const CreateClientButton = styled.button`
  background-color: ${(props) =>
    props.greencolor ? NewTheme.greencolor : NewTheme.MainColor};
  color: ${(props) => (props.greencolor ? "#ffffff" : NewTheme.lightmain)};
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s; /* Add smooth transitions */

  &:hover {
    background-color: #ffffff;
    color: ${(props) =>
      props.greencolor ? NewTheme.greencolor : NewTheme.MainColor};
    border: 1px solid
      ${(props) =>
        props.greencolor ? NewTheme.greencolor : NewTheme.MainColor};
  }
`;

export default function Customer() {
  const [refresh, setRefresh] = React.useState(false);

  const [visibleAddModal, setVisibleAddModal] = React.useState(false);
  const [position, setPosition] = React.useState("top");

  const showAddModal = () => {
    setVisibleAddModal(true);
  };

  const topworkui = (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: 20,
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: 30,
          flexDirection: "column",
        }}
      >
        <CreateClientButton
          greencolor
          style={{
            height: 30,
            marginRight: 30,
          }}
          onClick={() => showAddModal()}
        >
          + ADD CLIENT
        </CreateClientButton>
      </div>
    </div>
  );
  return (
    <div>
      <TopbarMost name={" Customers "} cmp={topworkui} />
      <CustomerTable refresh={refresh} />
      {visibleAddModal && (
        <AddCustomerModal
          key={new Date()}
          setVisible={() => setVisibleAddModal(false)}
          position={position}
          visible={visibleAddModal}
          reload={() => setRefresh(!refresh)}
        />
      )}
    </div>
  );
}
